import SaveIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton, InputAdornment } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import CustomSelect from "./CustomSelect";

const CustomEditControlSelect = ({ ...props }) => {
  const [readOnly, setReadOnly] = React.useState(true);

  const handleEdit = () => {
    setReadOnly(false);
  };
  const handleSaveEdit = () => {
    setReadOnly(true);
  };
  return (
    <Box sx={{ textAlign: "left" }}>
      <CustomSelect
        {...props}
        fullWidth={true}
        sx={{
          "& .MuiSelect-select": {
            // padding: "8.5px 14px",
            padding: "12px 14px",
          },
          "& .MuiSelect-select.MuiInputBase-readOnly": {
            backgroundColor: "#e5e5e5",
          },
        }}
        readOnly={readOnly}
        // InputProps={{
        //   readOnly: readOnly,
        // }}
      />
      <InputAdornment
        position="end"
        sx={{ float: "right", marginTop: "-23px", marginRight: "30px" }}
      >
        <IconButton onClick={readOnly ? handleEdit : handleSaveEdit}>
          {readOnly ? (
            <EditIcon sx={{ fontSize: "16px", color: "#1976d2" }} />
          ) : (
            <SaveIcon sx={{ fontSize: "16px", color: "#1976d2" }} />
          )}
        </IconButton>
      </InputAdornment>
    </Box>
  );
};

export default CustomEditControlSelect;
